import { useParams } from "react-router-dom";

import FileImageManager from "../components/FileImageManager";

export const UploadBannerImagePage = () => {
  const { tournamentId } = useParams();
  return (
    <div className="ticketCategoryPageWrapper">
      <h5 className="ticketCategoryPageTitle">Tournament Banner Image</h5>
      {tournamentId && (
        <FileImageManager
          label=""
          helperText="If left blank, the default banner image will be used."
          parentType="bannerImage"
          parentId={parseInt(tournamentId)}
          multiple={false}
        />
      )}
    </div>
  );
};
